import {Card, Stack, Switch, Typography} from '@mui/material';
import React from 'react';

import {formatText, getInitials} from 'presentation/utils';
import {BeneficiaryAvatar} from './styles';
import {AccessRowProps} from './types';

export function AccessRow({
	item,
	checked,
	disabled,
	description,
	onChange,
	action,
}: AccessRowProps) {
	const name = formatText(item.nomeMembro);

	return (
		<Card
			elevation={0}
			sx={{border: theme => `1px solid ${theme.palette.divider}`, borderRadius: 1, p: 2}}>
			<Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
				<Stack direction="row" alignItems="center" gap={2} minWidth={0}>
					<BeneficiaryAvatar>{getInitials(name)}</BeneficiaryAvatar>
					<Stack minWidth={0}>
						<Typography variant="body1" color="text.primary">
							{name}
						</Typography>
						{description ? (
							<Typography variant="body2" color="text.secondary">
								{description}
							</Typography>
						) : null}
					</Stack>
				</Stack>

				<Stack direction="row" alignItems="center" gap={3}>
					{action}
					<Switch
						checked={checked}
						disabled={disabled}
						onChange={event => onChange(event.target.checked)}
						inputProps={{'aria-label': `Permissão de acesso de ${name}`}}
					/>
				</Stack>
			</Stack>
		</Card>
	);
}
